import React from "react";

// Soft-deprecation banner — GitHub issue #96.
// ============================================================================
// Per-campaign scale / hold / reduce / kill recommendations now have ONE
// authoritative home: the v2 Opportunities screen
// (`/v2/workstation/opportunities`,
// `frontend/src/shell/routes/workstation/Opportunities.jsx`).
//
// The competing recommendation surfaces — the v1 Predictions dashboard and the
// Recommendations dashboard (rendered both at `/recommendations` and inside
// `/v2/operations/recommendations`) — are being retired, but NOT removed. They
// stay mounted, keep their routes, and keep showing their own data (nothing is
// deleted). This banner is the only change they get: an unmissable notice, at
// the very top of the screen, telling every operator who lands here where the
// authoritative surface now is, so nobody has to guess which screen to trust.
//
// It is a plain <a href>, not a router <Link>, so it works identically whether
// the host screen sits in the v1 router tree (App.js) or the v2 shell.
// ============================================================================

export const OPPORTUNITIES_PATH = "/v2/workstation/opportunities";

export default function DeprecationBanner({ surface, path = OPPORTUNITIES_PATH }) {
  return (
    <div
      data-testid="deprecation-banner"
      role="status"
      className="rounded-lg border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm text-amber-200 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between"
    >
      <div>
        <span className="font-semibold text-amber-300">This screen is being retired.</span>{" "}
        {surface ? `${surface} has moved. ` : ""}
        Per-campaign scale, hold, reduce and kill recommendations now live in one
        place — the Opportunities screen. Anything below still works, but the
        Opportunities screen is the surface to act from.
      </div>
      <a
        href={path}
        data-testid="deprecation-banner-link"
        className="shrink-0 inline-flex items-center justify-center rounded-md bg-amber-500 px-3 py-1.5 font-medium text-slate-900 transition-colors hover:bg-amber-400"
      >
        Go to Opportunities →
      </a>
    </div>
  );
}
